import { css } from 'styled-components';
import PaginationProStyle from "../templates/Pagination.style";
import PaginationHzeroStyle from "../templates-hzero/Pagination.style";
var PaginationStyle = css(["", ""], PaginationProStyle);
var paginationData = {
  name: 'pagination',
  data: [{
    itemWidth: 24,
    itemHeight: 24,
    itemRadius: 2,
    itemMargin: '',
    itemFontSize: 12,
    jumpSpan: 'block',
    jumpRight: 1
  }],
  onlyTemplate: {
    pro: PaginationProStyle,
    hzero: PaginationHzeroStyle
  }
};
export default paginationData;